import store from '@/store'
import axios from 'axios'

export default async function() {
  if (store.state.title === '') {
    const { data } = await axios('/api/studysys/common/getWebsiteAjax')
    return data.data
  }
  return store.state
}



// WEBPACK FOOTER //
// ./src/util/getWebsiteAjax.js